import { Applications } from './Applications';
import { DocumentServices, HostAPI, IExperimentsAPIFixMe } from './types';
import { PlatformPrivateEventEmitter } from '@wix/public-editor-platform-events';
import { ManifestServicesHost } from '@wix/editor-platform-manifest-services';
import { IEditorPlatformPackagesBridge } from '@wix/editor-platform-interfaces';
import { PrivateApiBIUtils } from './utils/biUtils';

export class PlatformPrivateServices {
  public apps: Applications;
  public biUtils: PrivateApiBIUtils;

  constructor(
    public ds: DocumentServices,
    public hostAPI: HostAPI,
    public events: PlatformPrivateEventEmitter,
    public experimentsAPI: IExperimentsAPIFixMe,
    public manifestServicesHost: ManifestServicesHost,
    public platformPackagesBridge: Partial<IEditorPlatformPackagesBridge>,
  ) {
    this.apps = new Applications(this.events);
    this.biUtils = new PrivateApiBIUtils(this.manifestServicesHost);
  }
}
